import { Typography } from "@hellocarbo/lasagne";
import { useTranslation } from "react-i18next";

import { IndustryComparison } from "@/types";

import Card from "../ui/Card";
import ComparisonDatabaseValue from "./ComparisonDatabaseValue";

type ComparisonDatabaseProps = {
  title: string;
  comparison: IndustryComparison;
};

function ComparisonDatabase({ title, comparison }: ComparisonDatabaseProps) {
  const { t } = useTranslation(["formatter", "review"]);

  const {
    reviews_count,
    companies_count,
    employee_min,
    employee_max,
    turnover_min,
    turnover_max,
  } = comparison;

  return (
    <Card>
      <Typography step="2" as="h2" className="mb-sm">
        {t("review:comparison.database.title")}
      </Typography>
      <div className="mb-lg">
        <Typography className="mb-3xs">
          {t("review:comparison.database.businessSector")}
        </Typography>
        <Typography weight="bold">{title}</Typography>
      </div>
      <div className="gap-sm grid grid-cols-2 grid-rows-2 xl:grid-cols-1 xl:grid-rows-none">
        <ComparisonDatabaseValue
          title={t("review:comparison.database.numberOfFootprints")}
          value={t("formatter:number", { value: reviews_count })}
        />
        <ComparisonDatabaseValue
          title={t("review:comparison.database.numberOfCompanies")}
          value={t("formatter:number", { value: companies_count })}
        />
        <ComparisonDatabaseValue
          title={t("review:comparison.database.turnovers")}
          value={`${t("formatter:currency", { value: turnover_min, maximumFractionDigits: 0 })} - ${t("formatter:currency", { value: turnover_max, maximumFractionDigits: 0 })}`}
        />
        <ComparisonDatabaseValue
          title={t("review:comparison.database.numberOfEmployees")}
          value={`${t("formatter:number", { value: employee_min })} - ${t("formatter:number", { value: employee_max })}`}
        />
      </div>
    </Card>
  );
}

export default ComparisonDatabase;
